import { useEffect, useState } from 'react'
import {
  fetchAndActivateRemoteConfig,
  getChatHistoryShadowReadFromRemote,
} from 'configs/firebase'

/**
 * `false` até o fetch; depois reflete `chat_history_shadow_read` (padrão:
 * false). Começa desligado de propósito: é medição em segundo plano que gasta
 * requisição, e o valor default nunca deve ligá-la sozinha em produção.
 */
export function useChatHistoryShadowRead(): boolean {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    let cancelled = false
    void (async () => {
      await fetchAndActivateRemoteConfig()
      if (cancelled) return
      setEnabled(getChatHistoryShadowReadFromRemote())
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return enabled
}
